import createRoute from '@widesk-ui/tools/createRoute';
import MenuModel   from '@models/admin/MenuModel';

export default createRoute.table(
	MenuModel.pagePath('list'),
	MenuModel.serviceName,
	'MenuTable',
	MenuModel.localize('plural'),
);